<template>
  <div class="landing-page">
    <div class="divider s3"></div>
    <div class="container">
      <container title="Contact">
        <div class="is-size-5 container2 desktop">
          <topic class="topic" v-for="topic in content" :key="topic.icon" :icon='topic.icon' :text='topic.name' :action='()=> redirect(topic.url)'/>
        </div>
        </container>
    </div>
  </div>
</template>

<script>

import container from "@/components/structure/Section.vue"
import topic from "@/components/structure/Topic.vue"

export default {
  name: 'About',
  components: {
    container,
    topic
  },
  data() {
    return {
      content: [
        {icon: 'linkedin.svg', name:'LinkedIn', url: 'https://www.linkedin.com/in/jo%C3%A3o-ferreira-299971136/'},
        {icon: 'git.svg', name:'GitHub', url: 'https://github.com/joaocsf'},
        {icon: 'gmail.svg', name:'Gmail', url: 'mailto:joaocsf.se@gmail.com'},
        {icon: 'twitter.svg', name:'Twitter', url: 'https://twitter.com/JFerreiraDev'},
      ]
    }
  },
  methods: {
    redirect(url) {
      window.location = url;
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page{
  margin: 0px;
  width: 100%;
  position: relative;
  color: white;
  background: var(--dark-color);
}


@media screen and (min-width:601px){
  .desktop{
    flex-direction: column;
  }
}

@media screen and (max-width:601px){
  .desktop{
    flex-direction: column !important;
    justify-content: center;
    align-items: center;
  }
}

.container div:last-child{
  padding-bottom: 0.5em;
}

.container2{
  justify-content: center;
  display: flex;
  flex-direction: row;
}

.topic{
  margin: 1em;
  margin-top: 0;
  font-size: 1.3em;
  width: 130px;
}

.col{
  height: 50%;
  display: flex;
}
.vertical{
  flex-direction: column;
}
.text{
  width:100%;
}

.align-bottom{
  align-items: flex-end;
  display: flex;
}

.align-top{
  align-items: flex-start;
  display: flex;
}

.name{
  font-family: 'caladea';
  font-style: italic;
  font-weight: bold;
}

.profession{
  color: var(--second-color);
  font-family: 'franklin gothic medium';
}

.quote{
  color: var(--second-color);
  opacity: 0.8;
  font-family: 'franklin gothic medium';
}


@media screen and (min-width:601px){
  .name{
    font-size: 5em;
  }
  .profession{
    font-size: 3em;
  }
  .quote{
    font-size: 1.5em;
  }
}

@media screen and (max-width:600px){
  .name{
    font-size: 4em;
  }
  .profession{
    font-size: 2.4em;
  }
  .quote{
    font-size: 1.5em;
  }
}



</style>
